import { Table, Tr, Th, Tbody, Thead, HStack } from '@chakra-ui/react';
import { Modal, ModalBody, ModalHeader, Button, Text } from 'components/UI';
import { IBom } from 'types/designAutomation/IDesAut';
import { LinkButton } from 'components/common/Buttons/LinkButton';
import { gradientStyle } from 'constants/theme';
import BomRow from './BomRow';

type BomModalProps = {
  bomRows?: IBom[];
  closePopup: () => void;
  bomCsvUrl?: string;
  isOpen: boolean;
};

const BomModal = ({ bomRows, closePopup, bomCsvUrl, isOpen }: BomModalProps) => {
  const renderFields = bomRows
    ? bomRows.map(({ part_number: partNumber, quantity, description }, i) => (
        <BomRow
          key={partNumber}
          partNumber={partNumber}
          quantity={quantity}
          description={description}
          version={i % 2 === 0 ? 1 : undefined}
        />
      ))
    : [];

  const renderBomCsvLink = bomCsvUrl ? (
    <LinkButton
      href={bomCsvUrl}
      sx={{
        ...gradientStyle,
        _focus: {
          boxShadow: 'none',
        },
        color: 'primaryFontColour.400',
        borderStyle: 'solid',
        w: 250,
      }}
      size="sm"
    >
      <Text color="primaryFontColour.400" letterSpacing={2}>
        DOWNLOAD{' '}
        <Text as="span" fontWeight="bold" color="primaryFontColour.400" letterSpacing={2}>
          CSV
        </Text>
      </Text>
    </LinkButton>
  ) : null;

  return (
    <Modal
      isOpen={isOpen}
      isCloseButton
      closeOnEsc={false}
      closeOnOverlayClick
      isCentered
      size="2xl"
      onClose={closePopup}
    >
      <ModalHeader textAlign="center" fontSize="3xl">
        BILL OF MATERIALS
      </ModalHeader>
      <ModalBody>
        <Table mb={8}>
          <Thead>
            <Tr h={30} fontSize={20} pl={6} pr={6} mb={4}>
              <Th textAlign="center">Part Number</Th>
              <Th textAlign="center">Description</Th>
              <Th textAlign="center">Quantity</Th>
            </Tr>
          </Thead>
          <Tbody mb={8} maxH={300} overflowY="auto">
            {renderFields}
          </Tbody>
        </Table>
        <HStack justifyContent="space-around" mb={8}>
          {renderBomCsvLink}

          <Button
            sx={{
              ...gradientStyle,
              _focus: {
                boxShadow: 'none',
              },
              color: 'primaryFontColour.400',
              borderStyle: 'solid',
              w: 250,
            }}
            size="sm"
            onClick={closePopup}
          >
            CLOSE
          </Button>
        </HStack>
      </ModalBody>
    </Modal>
  );
};

export default BomModal;
